import { render, staticRenderFns } from "./EditViewTermReportsSubjectRecords.vue?vue&type=template&id=778361a1"
import script from "./EditViewTermReportsSubjectRecords.vue?vue&type=script&lang=js"
export * from "./EditViewTermReportsSubjectRecords.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports